import React, { Component } from "react";
export class ReportSearch extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      fields: [
        {
          name: "school_id",
          type: "select",
          className: "status-dropdown",
          placeholder: "School",
          options: [],
          onChange: (...args) => {
            this.handleSchoolChange(...args);
          },
        },
        {
          name: "curriculum_id",
          type: "select",
          placeholder: "Class Grade",
          options: [],
          onChange: (...args) => {
            this.handleClassChange(...args);
          },
        },
        {
          name: "section_id",
          type: "select",
          placeholder: "Section",
          options: [],
          onChange: (...args) => {
            this.handleSectionChange(...args);
          },
        },
        { name: "topic", type: "select", placeholder: "Topics", options: [] },
        {
          name: "start_date",
          type: "date",
          placeholder: "Start Date",
        },
        {
          name: "end_date",
          type: "date",
          placeholder: "End Date",
        },
        {
          name: "event_status",
          type: "select",
          placeholder: "Status",
          options: _enum.EVENT_STATUS,
        },
      ],
    };
  }

  componentDidMount() {
    if (
      ["SCHOOL_ADMIN", "SCHOOL_COORDINATOR"].includes(
        localStorage.getItem("currentAdminRole")
      )
    ) {
      let schoolId = localStorage.getItem("school_id");
      this.getClassBySchool(schoolId);
    }
  }

  handleSchoolChange(val) {
    let schoolId = val[0]?.school_id;
    this.getClassBySchool(schoolId);
  }

  handleClassChange(val) {
    this.getModulesByClassSchool(val);
  }

  handleSectionChange(val) {
    console.log("handleSectionChange", val[0]);

    if (
      ["SUPER_ADMIN", "SCHOOL_ADMIN", "SCHOOL_COORDINATOR"].includes(
        localStorage.getItem("currentAdminRole")
      )
    ) {
      this.getTopics(val?.[0]?.class_id);
    }
  }

  getClassBySchool = (schoolId) => {
    let urlData = {};
    if (schoolId) {
      urlData.school_id = schoolId;
    } else {
      urlData.school_id = this.state.searchFields?.school_id;
    }
    this.props.api
      .apiGetClassById(urlData)
      .then((response) => {
        let data = response.data[0].records;
        data = data.sort((a, b) => a.curriculum_level - b.curriculum_level);
        let curriculumIdField = this.state.fields.find(
          (o) => o.name == "curriculum_id"
        );
        curriculumIdField.options = [
          ...data?.options("curriculum_id", "curriculum_name"),
        ];

        this.setState({
          ...this.state.fields,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loader: false,
        });
      });
  };

  getModulesByClassSchool = (record) => {
    let sectionField = this.state.fields.find((o) => o.name == "section_id");
    sectionField.options = [
      ...(record?.length > 0
        ? record[0]?.section?.options("section_id", "name")
        : []),
    ];
    this.setState({
      ...this.state.fields,
    });
  };

  getTopics(class_id) {
    let payload = {
      class_id: class_id,
    };
    this.setState({
      loader: true,
    });
    this.props.api
      .apiGetAccessedSessions(payload)
      .then(({ data }) => {
        console.log("TOPICS", data);

        let topicsField = this.state.fields.find((o) => o.name == "topic");
        topicsField.options = data?.options("session_id", "session_name");

        this.setState(
          {
            fields: this.state.fields,
          },
          () => {
            this.setState({
              loader: false,
            });
          }
        );
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  }

  // --------------------------------

  trimObjectValues(obj) {
    const trimmedObj = {};
    for (const key in obj) {
      if (typeof obj[key] === "string") {
        trimmedObj[key] = obj[key].trim();
      } else {
        trimmedObj[key] = obj[key];
      }
    }
    return trimmedObj;
  }

  onSearch() {
    let data = this.refs.form.form.current.getData();
    // console.log("onSearch formData", data);

    data = this.trimObjectValues(data);
    data = Object.filter(data, (val) => val);
    console.log("data on search", data);
    this.props.onSearch && this.props.onSearch(data);
  }

  clearTextData = () => {
    // clearing DOM input values here
    document.querySelector('.reportsearch [name="start_date"]').value = "";
    document.querySelector('.reportsearch [name="end_date"]').value = "";

    this.refs.form.form.current.reset();
    this.setState({
      fields: this.state.fields.map((field) => ({
        ...field,
        value: "",
        defaultValue: "",
      })),
    });
    let data = this.refs.form.form.current.getData();
    data = Object.filter(data, (val) => "");
    this.props.onSearch && this.props.onSearch(data);
  };

  handleInputChange = (i, event) => {
    const newFields = [...this.state.fields];
    if (newFields[i].name != "status") newFields[i].value = event.target.value;
    this.setState({ fields: newFields });
  };

  updateFields(fields) {
    fields.find((o) => o.name === "school_id").options =
      this.props.schooldata.options("school_id", "school_name");
    return fields;
  }

  render() {
    let { fields } = this.state;
    fields = this.updateFields(fields);

    return (
      <AppForm className="mb-4" ref="form">
        <div
          className={`search_grid_box reportsearch ${
            ["SUPER_ADMIN"].includes(localStorage.getItem("currentAdminRole"))
              ? "items_8"
              : "items_7"
          }`}
        >
          {fields
            ?.filter((v) =>
              ["SUPER_ADMIN"].includes(localStorage.getItem("currentAdminRole"))
                ? v
                : v.name !== "school_id"
            )
            .map((field, i) => (
              <div className="item" key={i}>
                <AppInputFocus
                  {...field}
                  // onChange={(event) => this.handleInputChange(i, event)}
                ></AppInputFocus>
              </div>
            ))}

          <span
            className="item clear-all d-flex align-items-center"
            onClick={() => this.clearTextData()}
          >
            Clear Filter
          </span>
          <div className="item position-relative">
            <button
              className="btn btn-success btn-block w-100"
              onClick={() => this.onSearch()}
            >
              Search
            </button>
          </div>
        </div>
      </AppForm>
    );
  }
}

export default connect(ReportSearch);
